import React from 'react';
import StatusChip from '../StatusChip';

interface PopupHeaderProps {
  title: React.ReactNode;
  status?: string;
  /** Pieces joined with " · "; empty ones are dropped. */
  meta?: (string | null | undefined | false)[];
  /** Buttons before the close button. */
  actions?: React.ReactNode;
  onClose?: () => void;
}

// Top bar of every centred pop-up: title with status chip, a muted meta line, actions, close.
const PopupHeader: React.FC<PopupHeaderProps> = ({
  title,
  status,
  meta = [],
  actions,
  onClose,
}) => (
  <div className="op-head">
    <div>
      <h4>
        {title}
        {status ? <StatusChip status={status} /> : null}
      </h4>
      {meta.some(Boolean) ? (
        <div className="op-meta">{meta.filter(Boolean).join(' · ')}</div>
      ) : null}
    </div>
    <div className="op-head-actions">
      {actions}
      {onClose ? (
        <button
          type="button"
          className="op-close"
          aria-label="Close (Esc)"
          title="Close (Esc)"
          onClick={onClose}
        >
          ×
        </button>
      ) : null}
    </div>
  </div>
);

export default PopupHeader;
